import { render, staticRenderFns } from "./NavigationNotificationIconSection.vue?vue&type=template&id=5bea773c&scoped=true"
import script from "./NavigationNotificationIconSection.vue?vue&type=script&lang=ts"
export * from "./NavigationNotificationIconSection.vue?vue&type=script&lang=ts"
import style0 from "./NavigationNotificationIconSection.vue?vue&type=style&index=0&id=5bea773c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea773c",
  null
  
)

export default component.exports